import { DOC_KINDS } from '@alluzo/shared/doc-kinds';
import { createFileRoute, Navigate } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { z } from 'zod';

import { DocOs } from '~/features/report-templates/os/doc-os';
import { useDocRights } from '~/features/report-templates/use-doc-rights';

/**
 * Generate new template (step 8.2 of docs/plans/report-templates.md): the OS
 * chat beside the live page. `?starter=` is a starter the tab offered, which
 * the chat asks for itself. Held as the tab's Generate new template button
 * is (`mayMake`): a person who may not change the fields, whose role keeps OS
 * from making changes, or who views as someone else lands on the tab.
 */
const search = z.object({ starter: z.enum(DOC_KINDS).optional() });

function NewTemplateRoute(): ReactElement {
  const { recordId } = Route.useParams();
  const { starter } = Route.useSearch();
  const { mayMake } = useDocRights(recordId);
  if (!mayMake) return <Navigate to="/records/$recordId/report-templates" params={{ recordId }} replace />;
  return <DocOs recordId={recordId} template={null} starter={starter ?? null} />;
}

export const Route = createFileRoute('/_app/records/$recordId/report-templates/new')({ validateSearch: search, component: NewTemplateRoute });
